import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from '../ui/Countdown';
import { trackInitiateCheckout } from '../MetaPixel';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
interface PricingSectionProps {
  id?: string;
  isReprise?: boolean;
}
const CHECKOUT_URL = 'https://360yoga.impultienda.ar/checkout';
const KIT_ITEMS = [{
  label: '12 Tomos digitales completos',
  value: '$47'
}, {
  label: '6 Bonos exclusivos',
  value: '$95'
}];
export function PricingSection({
  id,
  isReprise = false
}: PricingSectionProps) {
  const handleCheckout = () => {
    trackInitiateCheckout('profesional');
    window.location.href = CHECKOUT_URL;
  };
  return <section id={id} className="py-16 md:py-24 px-4 bg-hueso relative" data-id="element-169" data-mp="1p51dbisqc1lv">
      <div className="max-w-2xl mx-auto" data-id="element-170" data-mp="3ohndy7j6jgci">
        {/* Countdown header */}
        <div className="text-center mb-10" data-id="element-171" data-mp="3ogud1n6wjl2a">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-lg md:text-2xl font-extrabold text-terracota mb-5" data-id="element-172" data-mp="3ji12o3mwwa6c">
            {isReprise ? '⏰ El precio de lanzamiento cierra en:' : '⏰ El precio sube cuando termina el contador'}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} data-id="element-173" data-mp="sucb4z6zv0kh">
            <Countdown data-id="element-174" data-mp="o1j3a2g8bc46" />
          </motion.div>
        </div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-4xl md:text-6xl font-bold text-oscuro text-center leading-[1.05] mb-10" data-id="element-175" data-mp="1bs5c3vy250f8">
          <span aria-hidden="true" data-id="element-176" data-mp="1hepeqhkqrxlp">🏆</span> Oferta Especial de Lanzamiento
        </motion.h2>

        {/* Checkout card */}
        <motion.div id="elegi-tu-pack" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative bg-white rounded-[2rem] border-2 border-verdeOscuro/80 shadow-soft px-6 md:px-10 pt-10 pb-8 md:pb-10 scroll-mt-6" data-id="element-177" data-mp="1cfm9ox4rhrdq">
          {/* Content chip */}
          <div className="absolute -top-5 left-1/2 -translate-x-1/2" data-id="element-178" data-mp="oqjsfqe1i0jr">
            <span className="inline-block bg-verdeOscuro text-white text-xs md:text-sm font-bold uppercase tracking-widest px-6 py-2.5 rounded-full" data-id="element-179" data-mp="osw63rcrlor0">
              Contenido del kit:
            </span>
          </div>

          {/* Value breakdown */}
          <div className="divide-y divide-gray-100 mb-6 mt-2" data-id="element-180" data-mp="30ddid6u2oa26">
            {KIT_ITEMS.map((item, idx) => <div key={idx} className="flex items-center justify-between py-4" data-id="element-181" data-mp="35eb0xkizv647" data-mpi={idx}>
                <span className="text-base md:text-xl font-bold text-oscuro" data-id="element-182" data-mp="39f4noakpaevi">
                  {item.label}
                </span>
                <span className="text-base md:text-xl font-bold text-terracota line-through" data-id="element-183" data-mp="2cq5dur4gx517">
                  {item.value}
                </span>
              </div>)}
            <div className="flex items-center justify-between py-4" data-id="element-184" data-mp="2lo7l3oesotwx">
              <span className="text-lg md:text-2xl font-extrabold text-oscuro uppercase" data-id="element-185" data-mp="2qfqrdlzi0s1u">
                Valor total:
              </span>
              <span className="text-lg md:text-2xl font-extrabold text-terracota line-through" data-id="element-186" data-mp="1txb9er4h0vb8">
                $142
              </span>
            </div>
          </div>

          {/* Highlight price */}
          <div className="text-center mb-8" data-id="element-187" data-mp="1evkv5slmjs7g">
            <div className="flex items-center justify-center gap-2" data-id="element-188" data-mp="19w8anei86x81">
              <span className="text-4xl md:text-5xl" aria-hidden="true" data-id="element-189" data-mp="19tvjcaqkvaib">
                🏆
              </span>
              <span className="font-serif text-6xl md:text-7xl font-bold text-salvia leading-none" data-id="element-190" data-mp="1ompcv02opr5z">
                $19 USD
              </span>
            </div>
            <p className="text-lg md:text-xl font-bold text-terracota line-through mt-1" data-id="element-191" data-mp="1xk9gugrxm1ka">
              $142 USD
            </p>
          </div>

          {/* CTA (titila) */}
          <motion.button type="button" onClick={handleCheckout} animate={{
          scale: [1, 1.03, 1],
          boxShadow: ['0 10px 20px -6px rgba(20,52,43,0.35)', '0 16px 32px -6px rgba(20,52,43,0.6)', '0 10px 20px -6px rgba(20,52,43,0.35)']
        }} transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileTap={{
          scale: 0.98
        }} whileHover={{
          scale: 1.04
        }} className="w-full bg-verdeOscuro hover:bg-verdeOscuro/90 text-white font-extrabold uppercase tracking-wide py-5 px-6 rounded-full text-base md:text-2xl transition-colors duration-200" data-id="element-192" data-mp="27k0bcighsgkd">
            Quiero el kit Yoga 360
          </motion.button>

          {/* Guarantees line */}
          <p className="text-center text-gray-500 font-medium text-xs md:text-sm mt-6 leading-relaxed" data-id="element-193" data-mp="252z40h3r8ppi">
            Descarga inmediata · Pago único · Acceso de por vida
            <br className="sm:hidden" data-id="element-194" data-mp="1w56n58idxa00" /> · 7 días de garantía
          </p>

          <div className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-salvia/10 border border-salvia/30 px-4 py-3" data-id="element-195" data-mp="3litkyvar3nbk">
            <span className="text-lg" aria-hidden="true" data-id="element-196" data-mp="3qhwi7tkhop8z">
              🌎
            </span>
            <p className="text-center text-oscuro font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-197" data-mp="3p20t2ghfoulv">
              Pagarás en la moneda de tu país
            </p>
          </div>
        </motion.div>

        {/* Trust badges */}
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-198" data-mp="3f4whtbp4mjju">
          {[{
          icon: <Lock size={18} data-id="element-199" data-mp="bmcw6s0yeby0" />,
          label: 'Pago seguro'
        }, {
          icon: <Zap size={18} className="text-dorado" data-id="element-200" data-mp="6njkn5588v0h" />,
          label: 'Acceso en 5 min'
        }, {
          icon: <ShieldCheck size={18} className="text-salvia" data-id="element-201" data-mp="1vi0yy5qc20f" />,
          label: 'Garantía 7 días'
        }, {
          icon: <CreditCard size={18} data-id="element-202" data-mp="3t0rswvdaaqco" />,
          label: 'Tarjeta · Transferencia'
        }].map((badge, idx) => <div key={idx} className="flex items-center justify-center md:justify-start gap-2 text-gray-600 text-xs md:text-sm font-medium" data-id="element-203" data-mp="pmdvw45hfdbw" data-mpi={idx}>
              <span className="text-oscuro" data-id="element-204" data-mp="11wde5klmhx0e">{badge.icon}</span>
              {badge.label}
            </div>)}
        </div>
      </div>
    </section>;
}